import { render, staticRenderFns } from "./ArticleContent1.vue?vue&type=template&id=227d5335&"
import script from "./ArticleContent1.vue?vue&type=script&lang=js&"
export * from "./ArticleContent1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Heading: require('/app/components/heading/Heading.vue').default})
